import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { selectedBrandIdAtom } from '~/atoms';
import { updateStorageBrandId, clearStorageBrandId } from '~/utils';

export const useSelectedBrandId = () => {
  const [selectedBrandId, setSelectedBrandId] = useAtom(selectedBrandIdAtom);

  const handleBrandIdChange = useCallback(
    (brandId?: number) => {
      if (selectedBrandId === brandId) return;

      setSelectedBrandId(brandId);

      if (!brandId) {
        clearStorageBrandId();
      } else {
        updateStorageBrandId(brandId);
      }
    },
    [selectedBrandId, setSelectedBrandId]
  );

  return {
    brandId: selectedBrandId,
    onBrandChange: handleBrandIdChange,
  };
};
